// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .svg-selector-list {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  margin-top: 10px;
  right: 0px;
  left: 5px;
}
:host .svg-selector-item {
  font-size: 12px;
  line-height: 24px;
  cursor: pointer;
  padding-left: 5px;
  display: block;
}
:host .svg-selector-item .name {
  display: inline-block;
  width: 170px;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: bottom;
}
:host .svg-selector-item .id {
  display: inline-block;
  margin-left: 10px;
  color: darkgray;
  width: 150px;
}
:host .svg-selector-item .edit {
  width: 22px;
  height: 22px;
  line-height: 22px;
}
:host .svg-selector-item .edit mat-icon {
  font-size: 16px;
}
:host .svg-selector-item:hover {
  background-color: rgba(156, 156, 156, 0.2117647059);
}
:host .svg-selector-active {
  background-color: rgb(48, 89, 175);
}
:host .search-input-container {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 3px;
}
:host .search-input-container input {
  width: calc(100% - 10px);
}
:host .search-input-container .search-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #757575;
}`, "",{"version":3,"sources":["webpack://./src/app/editor/svg-selector/svg-selector.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/editor/svg-selector/svg-selector.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;ACAR;ADGI;EACI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDR;ADGQ;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;ACDZ;ADIQ;EACI,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;ACFZ;ADKQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACHZ;ADKY;EACI,eAAA;ACHhB;ADQI;EACI,mDAAA;ACNR;ADSI;EACI,kCAAA;ACPR;ADUI;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;ACRR;ADUQ;EACI,wBAAA;ACRZ;ADWQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;ACTZ","sourcesContent":[":host {\n    .svg-selector-list {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        margin-top: 10px;\n        right: 0px;\n        left: 5px;\n    }\n\n    .svg-selector-item {\n        font-size: 12px;\n        line-height: 24px;\n        cursor: pointer;\n        padding-left: 5px;\n        display: block;\n\n        .name {\n            display: inline-block;\n            width: 170px;\n            font-size: 13px;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow: hidden;\n            vertical-align: bottom;\n        }\n\n        .id {\n            display: inline-block;\n            margin-left: 10px;\n            color: darkgray;\n            width: 150px;\n        }\n\n        .edit {\n            width: 22px;\n            height: 22px;\n            line-height: 22px;\n\n            mat-icon {\n                font-size: 16px;\n            }\n        }\n    }\n\n    .svg-selector-item:hover {\n        background-color: #9c9c9c36;\n    }\n\n    .svg-selector-active {\n        background-color: rgba(48, 89, 175, 1);\n    }\n\n    .search-input-container {\n        position: relative;\n        width: 100%;\n        margin-bottom: 10px;\n        margin-top: 3px;\n\n        input {\n            width: calc(100% - 10px);\n        }\n\n        .search-icon {\n            position: absolute;\n            right: 8px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: #757575;\n        }\n    }\n}",":host .svg-selector-list {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  margin-top: 10px;\n  right: 0px;\n  left: 5px;\n}\n:host .svg-selector-item {\n  font-size: 12px;\n  line-height: 24px;\n  cursor: pointer;\n  padding-left: 5px;\n  display: block;\n}\n:host .svg-selector-item .name {\n  display: inline-block;\n  width: 170px;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  vertical-align: bottom;\n}\n:host .svg-selector-item .id {\n  display: inline-block;\n  margin-left: 10px;\n  color: darkgray;\n  width: 150px;\n}\n:host .svg-selector-item .edit {\n  width: 22px;\n  height: 22px;\n  line-height: 22px;\n}\n:host .svg-selector-item .edit mat-icon {\n  font-size: 16px;\n}\n:host .svg-selector-item:hover {\n  background-color: rgba(156, 156, 156, 0.2117647059);\n}\n:host .svg-selector-active {\n  background-color: rgb(48, 89, 175);\n}\n:host .search-input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: 10px;\n  margin-top: 3px;\n}\n:host .search-input-container input {\n  width: calc(100% - 10px);\n}\n:host .search-input-container .search-icon {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #757575;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
